import React from 'react';
import { Container, Title, Divider } from './styles';

// This is the component that will be displayed to the student
// when there is issue retrieving data from "loadDeploymentData" in the code.
const DataMissing = () => (
  <Container>
    <Title>Please relaunch this assignment from within your course.</Title>
    <Divider />
  </Container>
);

export default DataMissing;
